import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import MaintenanceLayout from './layout/MaintenanceLayout';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const isMaintenanceMode:boolean = process.env.REACT_APP_MAINTENANCE_MODE === "true";

root.render(
  // <React.StrictMode>
  isMaintenanceMode ? <MaintenanceLayout /> : <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
